import { useEffect, useState } from "react";
import { Dropdown, Modal } from "react-bootstrap";
import Spinner from "../../Components/Spinner";
import ErrorMessage from "../../Components/ErrorMessage";
import MandatorySign from "../../Components/MandatorySign";
import { CiCircleAlert } from "react-icons/ci";
import { MdOutlineCheckCircle, MdOutlineCircle } from "react-icons/md";
import { useNavigate, useParams } from "react-router-dom";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { useLanguage } from "../../Translations/LenguageContext";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const NewCardModal = ({
    account_id,
    show,
    handleClose,
    defaultCard,
    fetchData
}) => {
    const {t} = useLanguage()
    const navigate = useNavigate()
    const stripe = useStripe();
    const elements = useElements();

    const [loadingSave, setLoadingSave] = useState(false);
    const [paymentId, setPaymentId] = useState(null)
    const [isAutomaticRechargeEnable, setIsAutomaticRechargeEnabled] = useState(false)
    const [errorMessage, setErrorMessage] = useState({ message: "", display: false });
    const [paymentName, setPaymentName] = useState("")
    const [isDefault, setIsDefault] = useState(false)

    const handleSave = async () => {
        if (!stripe || !elements) return;

        if (!paymentName.trim()) {
            setErrorMessage({ message: t.billing.pyment_method_name_required, display: true });
            return;
        }

        setLoadingSave(true);
        setErrorMessage({ message: "", display: false });

        try {
            const cardElement = elements.getElement(CardElement);

            const { paymentMethod, error } = await stripe.createPaymentMethod({
                type: "card",
                card: cardElement,
            });

            if (error) {
                throw new Error(error.message);
            }

            const response = await fetch(`${GEN_BACKEND_LINK}/save_new_payment_method`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    account_id,
                    payment_method_id: paymentMethod.id,
                    payment_method_name: paymentName,
                    is_default: isDefault
                }),
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || "Something went wrong");
            }

            closeModal();
            fetchData()

        } catch (error) {
            setErrorMessage({
                message: error.message || "Server error",
                display: true
            });
        } finally {
            setLoadingSave(false);
        }
    };

    const closeModal = () => {
        handleClose();
        setErrorMessage({ message: "", display: false });
        setIsAutomaticRechargeEnabled(false)
        setLoadingSave(false);
        setPaymentName("")
    };

    const computedColor = getComputedStyle(document.documentElement)
        .getPropertyValue("--originalBlack")
        .trim();

    const computedColorPlaceholder = getComputedStyle(document.documentElement)
        .getPropertyValue("--originalGray")
        .trim();


    return (
        <Modal show={show} centered onHide={closeModal}>
            <div className="modal_header">
                <p className="modal_header_title">
                    {t.billing.add_payment_method}
                    {isDefault && (
                        <span className="fade-in">{t.billing.default}</span>
                    )}
                </p>
            </div>

            <div className="modal_main_cont">
                <div className="new_card_modal">
                    <div className="modal_profile_input_cont">
                        <div className="label_input">
                            <label className="input_label">{t.billing.pay_method_name} <MandatorySign message={t.mandatory_field} /></label>
                            <input
                                type="text"
                                name="paymentMethodName"
                                value={paymentName}
                                onChange={(e) => setPaymentName(e.target.value)}
                                placeholder="Ex. My card"
                                className="register_form_first fade-in"
                                autoComplete="off"
                            />
                        </div>

                        <div className="label_input">
                            <label className="input_label">
                                {t.billing.card_details} <MandatorySign message={t.mandatory_field} />
                            </label>

                            <div className="card_det_container">
                                <div className="card_det">
                                    <CardElement
                                        options={{
                                            hidePostalCode: true,
                                            style: {
                                                base: {
                                                    fontSize: "14px",
                                                    color: computedColor,
                                                    "::placeholder": {
                                                        color: computedColorPlaceholder
                                                    }
                                                }
                                            }
                                        }}
                                    />
                                </div>
                            </div>

                        </div>

                        <div className="automatic_recharge_cont_quest">
                            <p className="automatic_recharge_cont_quest_title">{t.billing.set_default}?</p>
                            <label className="switch_container">
                                <input
                                    id="web-search-toggle"
                                    type="checkbox"
                                    checked={isDefault}
                                    onChange={() => setIsDefault(!isDefault)}
                                />
                                <span className="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <p className="role_warning_text" dangerouslySetInnerHTML={{__html: t.payments.sensitive_mex}}>
                    </p>
                </div>
            </div>

            <div className="modal_footer">
                <div className="modal_footer_err_cont">
                    <ErrorMessage err={errorMessage} />
                </div>

                <div className="modal_footer_btn_cont">
                    <button
                        className="modale_save_btn"
                        onClick={handleSave}
                        disabled={loadingSave}
                    >
                        {loadingSave ? <Spinner loading={true} /> : t.save}
                    </button>

                    <button
                        className="modale_close_btn"
                        onClick={closeModal}
                        disabled={loadingSave}
                    >
                        {t.close}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default NewCardModal;